<header class="header--mobile">
  <img [src]="logo" alt="San Cristóbal" class="header__logo" (click)="goBack()"/>
</header>

<header class="header--desktop">
  <img [src]="logo" alt="San Cristóbal" class="header__logo" (click)="goBack()"/>
  <sc-auth-actions [authAction]="authAction"></sc-auth-actions>
</header>
